import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import type { Question } from '@core/intelligence-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

export interface AssistantConfig {
  ask: {
    enabled: boolean;
  };
  greeting: string;
  status: 'disabled' | 'preview' | 'enabled';
  wiki: {
    enabled: boolean;
    questions: Question[];
  };
}

@Injectable({ providedIn: 'root' })
export class AssistantConfigHttp {
  private httpApi = injectTellentIntelligenceHttp();

  public fetch() {
    return this.httpApi
      .get('/assistant/config', null, null)
      .pipe(map((response): AssistantConfig => response.data));
  }
}
